import React from 'react';

const RankIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.00275 0L0.242188 3.83099L2.98199 5.1831L7.00275 2.92958V0Z",
      fill: "#D4D4D4"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.242188 3.83099L0.918244 12.3944L3.39712 10.8169L2.98199 5.1831L0.242188 3.83099Z",
      fill: "#C6C6C6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.7633 3.83099L7.00275 0V2.92958L11.0235 5.1831L13.7633 3.83099Z",
      fill: "#C6C6C6"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.0873 12.3944L13.7633 3.83099L11.0235 5.1831L10.6084 10.8169L13.0873 12.3944Z",
      fill: "#9A9A9A"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.00275 16L13.0873 12.3944L10.6084 10.8169L7.00275 12.8451V16Z",
      fill: "#7D7D7D"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.918244 12.3944L7.00275 16V12.8451L3.39712 10.8169L0.918244 12.3944Z",
      fill: "#9A9A9A"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.00275 2.92958L2.98199 5.1831L3.39712 10.8169L7.00275 12.8451L10.6084 10.8169L11.0235 5.1831L7.00275 2.92958Z",
      fill: "#B8B8B8"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.72106 5.1831L0.242188 3.83099L2.83374 4.95775L6.89007 2.70422L7.00275 0L7.11543 2.70422L11.1718 4.95775L13.7633 3.83099L11.3971 5.1831L11.0589 10.8365L13.0873 12.3944L10.8169 11.2167L7.2281 13.1831L7.00275 16L6.7774 13.1831L3.18858 11.2167L0.918244 12.3944L3.05909 10.8169L2.72106 5.1831ZM3.39712 10.8169L7.00275 12.8451L10.6084 10.8169L10.9464 5.1831L7.00275 2.92958L3.05909 5.1831L3.39712 10.8169Z",
      fill: "white"
    }
  )
);
RankIcon.displayName = "Icons.RankIcon";

export { RankIcon };
//# sourceMappingURL=RankIcon.js.map
